import { render, staticRenderFns } from "./lztAbout.vue?vue&type=template&id=748b89d1&"
import script from "./lztAbout.vue?vue&type=script&lang=js&"
export * from "./lztAbout.vue?vue&type=script&lang=js&"
import style0 from "./lztAbout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports